exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-11-wrapper[data-v-21047a84]{width:180px;padding-bottom:10px}.listing-img[data-v-21047a84]{width:24px;height:24px;border-radius:50%}", ""]);

// exports
